{
  "dismiss": "Zrušiť"
}